import React, { useEffect, useState } from "react";

const useBackButton = (callback) => {


    const handleEvent = (e) => {
        console.log('back button');
        callback(e);
        // window.history.pushState(null, "");
        // window.history.go(0);
    };

    useEffect(() => {
        window.onpopstate = handleEvent;
        return () => { window.onpopstate = undefined }
    }, []);

};

export default useBackButton;